import axios from "@/api/axiosInstance";
import { EditAdminUserRequest, EditAdminUserResponse } from "./types";

export const editAdminUser = async (
  uuid: string,
  requestData: EditAdminUserRequest,
): Promise<EditAdminUserResponse> => {
  const response = await axios.put<EditAdminUserResponse>(
    `/api/private/admin/employees/${uuid}`,
    requestData,
  );
  return response.data;
};
